import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./SignIn.css";
import { useRol } from "../../Context";
import bg1 from '../../icons/bg1.jpg';
import bg2 from '../../icons/bg2.jpg';
import bg3 from '../../icons/bg3.jpg';
import logo from '../../icons/logo.png';
import fb from '../../icons/logo-facebook.svg';
import tw from '../../icons/logo-twitter.svg';
import db from '../../icons/logo-dribbble.svg';
import logoMovil from '../../icons/Isologo-blanco.png';
import enter from '../../icons/enter-outline.svg';
import { Loading } from "../../Components/UX/Loading";


function SignIn() {

    const navigate = useNavigate();

    const [currentIndex, setCurrentIndex] = useState(0);

    const images = [bg1, bg2, bg3];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 10000);

        return () => clearInterval(interval);
    });

    const { setLogin, setButtonPressed, loading, responseStatus, errorLogin, setErrorLogin } = useRol();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        setLogin({ email, password });
        setButtonPressed(true);
    };

    // useEffect para manejar la respuesta del login
    useEffect(() => {
        if (responseStatus === 202) {
            navigate('/Inicio');
        } else if (responseStatus === 401) {
            setErrorLogin(true);
        } else if (responseStatus === 404) {
            setErrorLogin(true);
        }
    }, [responseStatus, navigate, setErrorLogin]);

    const [botonHabilitado, setBotonHabilitado] = useState(false);

    useEffect(() => {
        const habilitarBotonDespuesDe5Segundos = () => {
            setTimeout(() => {
                setBotonHabilitado(true);
            }, 5000);
        };
        habilitarBotonDespuesDe5Segundos();
        return () => {
        };
    }, []);

    return (
        <> {loading ? <Loading /> : <div>
            <div className="general-signin">
                <div
                    className="imagen-big-signin"
                    style={{
                        backgroundImage: `url(${images[currentIndex]})`,
                    }}
                >
                    <img src={logo} alt="logo" />
                </div>
                <div className="contenido-signin">
                    <div className="form-signin">
                        <label>Inicio de sesión</label>
                        <p>Bienvenido a nuestro CRM Inmobiliario Prospectia RS. Si aún no tienes cuenta <NavLink to={'/sign-up'} className='nav-links-login'>regístrate aquí</NavLink> sin costo.</p>
                        {errorLogin && <div className="error-message-login">
                            Correo y/o contraseña no validos
                        </div>}
                        <form onSubmit={handleSubmit}>
                            <div className="inputs-login">
                                <input
                                    type="email"
                                    name="email"
                                    autoComplete="email"
                                    placeholder="Correo"
                                    required
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <input
                                    type="password"
                                    name="password"
                                    autoComplete="current-password"
                                    placeholder="Contraseña"
                                    required
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                            <button disabled={!botonHabilitado} type="submit">INICIAR</button>
                        </form>
                        <span>¿Olvidaste tu contraseña?</span>
                    </div>
                    <div className="footer-login">
                        <div className="logos-login">
                            <img src={fb} alt="fb" />
                            <img src={tw} alt="tw" />
                            <img src={db} alt="db" />
                        </div>
                        <div className="prospectia">
                            Copyright © Prospectia 2024
                        </div>
                    </div>
                </div>
            </div>
            <div className="singin-movil">
                <div className="logo-sigin-movil">
                    <img src={logoMovil} alt="logoMovil" />
                </div>
                <div className="form-sigin-movil">
                    <form onSubmit={handleSubmit}>
                        <input
                            type="email"
                            name="emailMovil"
                            autoComplete="email"
                            placeholder="Correo"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <input
                            type="password"
                            name="passwordMovil"
                            autoComplete="current-password"
                            placeholder="Contraseña"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <button type="submit" className="btn-login">
                            <img src={enter} alt="enter" />
                            INICIAR
                        </button>
                    </form>
                    <p>Si aún no tienes cuenta, <NavLink to={'/sign-up'} className="nav-links-movil link">regístrate aquí</NavLink> sin costo.</p>
                </div>
            </div>
        </div>
        }
        </>
    )
}

export { SignIn }